import React, { useEffect, useRef } from 'react';

function HeaderMarquee() {
    const marqueeRef = useRef(null);
    const contentRef = useRef(null);

    useEffect(() => {
        const marquee = marqueeRef.current;
        const content = contentRef.current;
        let animationId;
        let position = 0;

        const animate = () => {
            position -= 1;
            if (position <= -content.offsetWidth) {
                position = marquee.clientWidth;
            }
            content.style.transform = `translateX(${position}px)`;
            animationId = requestAnimationFrame(animate);
        };

        animate();

        const pauseAnimation = () => cancelAnimationFrame(animationId);
        const resumeAnimation = () => {
            cancelAnimationFrame(animationId);
            animationId = requestAnimationFrame(animate);
        };

        marquee.addEventListener('mouseenter', pauseAnimation);
        marquee.addEventListener('mouseleave', resumeAnimation);

        return () => {
            cancelAnimationFrame(animationId);
            marquee.removeEventListener('mouseenter', pauseAnimation);
            marquee.removeEventListener('mouseleave', resumeAnimation);
        };
    }, []);

    return (
        <div className='bg-[#b7e1fc] md:px-[120px]'>
            <div ref={marqueeRef} className='overflow-hidden whitespace-nowrap'>
                <div ref={contentRef} className='inline-block'>
                    <p className='text-sm text-black pt-2'>
                        For hospitalisation claims related to Kerala landslide, connect with our Nodal Officer, Mr Jojy Thomas at 9809778777 or call our helpline at 040-68178534
                    </p>
                </div>
            </div>
        </div>
    );
}

export default HeaderMarquee;